import { render, staticRenderFns } from "./FindologicItemFilterTagList.vue?vue&type=template&id=2e7461dd&scoped=true&"
import script from "./FindologicItemFilterTagList.vue?vue&type=script&lang=ts&"
export * from "./FindologicItemFilterTagList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7461dd",
  null
  
)

export default component.exports